import { render } from "./removePublishIcon.vue?vue&type=template&id=3599e206"
import script from "./removePublishIcon.vue?vue&type=script&lang=js"
export * from "./removePublishIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__